export const cartFlowCommon = {
	tealium_event: 'cart_flow',
	interaction_source: 'page',
	cart_payment_type: '',
} as const;

export const cartFlowCheckoutInitiated = {
	cart_step: '1',
	cart_step_label: 'checkout initiated',
} as const;

export const cartFlowFulfilmentSubmitted = {
	cart_step: '2',
	cart_step_label: 'fulfilment details submission',
};

export const fulfilmentChangeLoadTimeslots = {
	tealium_event_label: 'fulfillment preference timeslot page load',
	tealium_event_step: 3,
} as const;

export const fulfilmentChangeCompleted = {
	tealium_event_label: 'fulfillment preference completed',
	tealium_event_step: 4,
} as const;
